import { initializeApp } from 'firebase/app'
import { getAuth } from 'firebase/auth'

// Validate that we can access environment variables
if (typeof import.meta.env === 'undefined') {
    throw new Error('Environment variables are not accessible. Make sure you are using Vite and your .env file is properly configured.');
}

// Admin Firebase configuration (dedicated project)
const firebaseConfig = {
    apiKey: import.meta.env.VITE_ADMIN_FIREBASE_API_KEY,
    authDomain: import.meta.env.VITE_ADMIN_FIREBASE_AUTH_DOMAIN,
    projectId: import.meta.env.VITE_ADMIN_FIREBASE_PROJECT_ID,
    storageBucket: import.meta.env.VITE_ADMIN_FIREBASE_STORAGE_BUCKET,
    messagingSenderId: import.meta.env.VITE_ADMIN_FIREBASE_MESSAGING_SENDER_ID,
    appId: import.meta.env.VITE_ADMIN_FIREBASE_APP_ID
}

if (!firebaseConfig.apiKey) {
    console.error('Firebase configuration error: API Key is missing');
    throw new Error('Firebase API Key is missing. Make sure your .env file is set up correctly and you have restarted your development server.');
}

const app = initializeApp(firebaseConfig)
export const auth = getAuth(app)
export default app


